<template>
  <div class="info-container">
    <div class="info-row">
      <div class="info-label">农事服务商名称：</div>
      <div class="info-value">{{ info.busName }}</div>
    </div>
    <div class="info-row">
      <div class="info-label">联系方式：</div>
      <div class="info-value">{{ info.phone }}</div>
    </div>
    <div class="info-row">
      <div class="info-label">地址：</div>
      <div class="info-value">{{ info.busAddress }}</div>
    </div>
    <div class="info-row">
      <div class="info-label">经营范围：</div>
      <div class="info-value">{{ info.busRange }}</div>
    </div>
    <div class="info-row button-row">
      <el-button class="custom-button" @click="handleClick(info)">
        在线沟通
      </el-button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { SendMessage, companyByid } from "@/api/websocket.js";
import { getStore } from "@/js/utils/store";
export default {
  props: ["info"],
  computed: {
    ...mapGetters(["topSelectAreacode", "topSelectAreaname", "identityObj"]),
  },
  methods: {
    /**
     * 在线沟通
     */
    async handleClick(info) {
      let token = getStore({ name: "access_token" });
      if (!token) {
        this.$router.push({ name: "login" });
        this.$message.error("用户凭证已过期");
        return;
      }
      if (info.authId == this.identityObj.identityId) {
        this.$message.info("本人项目");
      } else {
        let content2 = JSON.stringify(info);
        let params = {
          messageList: [
            {
              //消息类型会话托管
              messageType: 5,
            },
          ],
          receiverId: info.authId,
          senderType: this.identityObj.identityTypeCode,
          //接受消息人类型只有公司认证用户
          receiverType: 4,
          senderId: this.identityObj.identityId,
          sender: this.identityObj.realName,
          receiver: info.busName,
        };
        let res = await SendMessage(params);
        if (res.code == 0) {
          console.log(this.$router, "发送成功");
          this.$router.push({
            path: "/home/Chat",
            query: {
              isshow: true, // 你要传递的参数
              // data: info,
              num: 1,
            },
          });
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/styles/JStyle";
.info-container .info-row .info-label {
  width: 110px;
}
</style>
